'use strict';

var util = require('../util/utils');

/**
 * Reusable slick carousel configurations
 * @example - $('.product-carousel').slick(slickConfigs.pdp)
 */

module.exports = {
    hero: {
        autoplay: true,
        accessibility: false,
        autoplaySpeed: 5000,
        easing: 'swing',
        infinite: true,
        speed: 800,
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1
    },

    productTiles: {
        infinite: false,
        speed: 300,
        dots: true,
        accessibility: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: util.getViewports('lg'),
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: util.getViewports('md'),
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerPadding: '35px',
                    arrows: false,
                    dots: true
                }
            }
        ]
    },

    cartProductRecs: {
        infinite: false,
        speed: 300,
        dots: true,
        appendDots: $('.RecommendationsInsideCart'),
        accessibility: false,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: util.getViewports('xl'),
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: util.getViewports('md'),
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerPadding: '35px',
                    arrows: false,
                    dots: true
                }
            }
        ]
    },

    productTilesIntercept: {
        infinite: false,
        accessibility: false,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        speed: 300,
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: util.getViewports('lg'),
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: false
                }
            },
            {
                breakpoint: util.getViewports('sm'),
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false
                }
            }
        ]
    },

    quickview: {
        dots: true,
        accessibility: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        speed: 400,
        lazyLoad: 'ondemand',
        arrows: false
    },

    pdp: {
        dots: false,
        accessibility: false,
        vertical: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        speed: 400,
        lazyLoad: 'anticipated',
        arrows: false,
        asNavFor: '.product-small-carousel',
        responsive: [{
            breakpoint: util.getViewports('th'),
            settings: {
                vertical: false,
                dots: true,
                lazyLoad: 'ondemand'
            }
        }]
    },

    headerPromo: {
        autoplay: false,
        accessibility: false,
        easing: 'linear',
        infinite: true,
        speed: 500,
        dots: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1
    },

    contentBlock: {
        autoplay: false,
        accessibility: false,
        easing: 'swing',
        infinite: false,
        speed: 1000,
        dots: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: util.getViewports('lg'),
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    },

    videoTiles: {
        infinite: true,
        accessibility: false,
        speed: 300,
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: util.getViewports('sm'),
                settings: 'unslick'
            }
        ]
    },

    feature: {
        infinite: true,
        accessibility: false,
        speed: 300,
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: util.getViewports('sm'),
                settings: 'unslick'
            }
        ]
    },

    partsTiles: {
        infinite: false,
        lazyLoad: 'ondemand',
        accessibility: false,
        speed: 300,
        dots: true,
        arrows: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: util.getViewports('lg'),
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: util.getViewports('md'),
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    variableWidth: true,
                    centerMode: true,
                    arrows: false,
                    dots: true
                }
            }
        ]
    },

    blogTiles: {
        infinite: true,
        accessibility: false,
        speed: 300,
        dots: true,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    },

    blogArticle: {
        infinite: true,
        accessibility: false,
        speed: 600,
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: util.getViewports('md'),
                settings: 'unslick'
            }
        ]
    }
};
